import enLocale from 'element-ui/lib/locale/lang/en'
import login from './login'

export default {
  login,
  ...enLocale,
}
